import React, { createContext, useContext, useState, useEffect } from "react";
import * as API from "../../src/utils/api.service";
import { Encryption } from "../utils/common.service";

const CredentialContext = createContext();

export const CredentialProvider = ({ children }) => {
  const [credentials, setCredentials] = useState(null);

  useEffect(() => {
    const fetchCredentials = async () => {
      try {
        const { code, data } = await API.getCredentialApi();
        if (code == 1) {
          setCredentials(data);
          // console.log(' data :',  data);
          localStorage.setItem("credential", Encryption(data,true));
        } else {
          console.log("Oops! Something went wrong");
        }
      } catch (error) {
        console.log("Error fetching credentials:", error);
      }
    };

    fetchCredentials();
  }, []);

  return (
    <CredentialContext.Provider value={credentials}>
      {children}
    </CredentialContext.Provider>
  );
};

export const useCredentials = () => useContext(CredentialContext);
